import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithSeventeen = () => {
  return (
    <KpopStudyPageTemplate
      groupName="SEVENTEEN"
      groupNameDisplay="SEVENTEEN"
      fandomName="CARATs"
      seoTitle="Study With SEVENTEEN - SEVENTEEN Study Rooms"
      seoDescription="Study with SEVENTEEN fans worldwide. Join CARATs in virtual study rooms with SVT playlists and productivity tools."
      seoKeywords="study with seventeen, svt study room, carat study, kpop study room"
      canonicalUrl="/study-with-seventeen/"
      heroDescription="Join a global community of CARATs who combine their passion for SEVENTEEN with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://www.seventeen-17.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">SEVENTEEN</a> is a South Korean boy band formed by <a href="https://www.pledis.co.kr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Pledis Entertainment</a> in 2015. With 13 members divided into three specialized units, SEVENTEEN is known for their synchronized performances.
          </p>
          <p>
            SEVENTEEN's fanbase, known as CARAT, shines bright like diamonds. Follow them on <a href="https://www.instagram.com/saythename_17/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/pledis_17" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@SEVENTEEN" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          SEVENTEEN fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/7nqOGRxlXj7N2JYbgNEjYH" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">SEVENTEEN's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "SEVENTEEN Study Playlists", desc: "Curated playlists featuring SVT's music to keep you motivated." },
        { title: "Connect with CARAT", desc: "Meet fellow CARATs from around the world who share your passion." },
        { title: "Diamond-Themed Rooms", desc: "Study rooms with SEVENTEEN-inspired aesthetics that shine bright." },
        { title: "Unit Study Sessions", desc: "Choose rooms themed around your favorite SVT unit." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of SEVENTEEN can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://www.seventeen-17.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@SEVENTEEN" },
        { name: "Instagram", url: "https://www.instagram.com/saythename_17/" },
        { name: "X (Twitter)", url: "https://twitter.com/pledis_17" },
        { name: "Spotify", url: "https://open.spotify.com/artist/7nqOGRxlXj7N2JYbgNEjYH" },
      ]}
      youtubeVideos={[
        { id: "J-wFp43XOrA", title: "SEVENTEEN - Super M/V" },
        { id: "_eju_7CQ8LE", title: "SEVENTEEN - MAESTRO M/V" },
        { id: "WpuXi14ZSFI", title: "SEVENTEEN - LALALI M/V" },
        { id: "gGjXVp8b_9g", title: "SEVENTEEN - HOT M/V" },
        { id: "Fr8jbFJxLRA", title: "SEVENTEEN - Rock with you M/V" },
        { id: "7tAx9bHf_M8", title: "SEVENTEEN - LOVE, MONEY, FAME M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@SEVENTEEN"
      youtubeChannelName="SEVENTEEN"
    />
  );
};

export default StudyWithSeventeen;
